module.exports = __webpack_public_path__ + "img/PAMMAccountRunPrincipleM.25ef7fdd.png";